<button
  type="button"
  class="scg-unstyled-button scg-info-circle"
  [tooltip]="tooltipContent"
  [placement]="popupPlacement"
  triggers="focus"
  container="body"
  containerClass="scg-info-popup-tooltip"
  [ngStyle]="{'color': (isWarning===true) ? 'red' : '#a0a0a0'}"
  #infoPopupButton
>
  <app-svg-icon [name]="'info-circle'"></app-svg-icon>
</button>

<ng-template style="opacity: 1"#tooltipContent><ng-content></ng-content></ng-template>
